import React, { useEffect, useState } from "react";
import { Message } from "semantic-ui-react";
import { apiPhp } from "../../../utils/Common";
import moment from "moment";

const TablaActividades = (props) => {
  const { uuid, plan } = props;
  console.log(uuid, plan);

  const [actividades, setActividades] = useState([]);

  useEffect(() => {
    apiPhp.get('get-actividades-realizadas', {
      params: { uuid, plan_siembra: plan }
    }).then( r => {
      console.log( r.data );
      setActividades([ ...r.data.actividades ]);
    })
  }, [ uuid, plan ]);

  return (
    <React.Fragment>
      {actividades.length > 0 ? 
        (<table className="ui table">
              <thead>
                  <tr style={{ textAlign: 'center' }}>
                      <th>Usuario</th>
                      <th>Actividad</th>
                      <th>Cantidad</th>
                      <th>UM</th>
                      <th>Fórmula</th>
                      <th>Fecha Creación</th>
                  </tr>
              </thead>
              <tbody>
                  { 
                    actividades.map(( a,j ) => {
                          return (
                              <tr key={ j }>
                                  <td>{ a.user.nombre }</td>
                                  <td>{ a.actividad }</td>
                                  <td style={{ textAlign: 'right' }}>{ a.cantidad }</td>
                                  <td style={{ textAlign: 'center' }}>{ a.um }</td>
                                  <td>{ a.formula }</td>
                                  <td style={{ textAlign: 'center' }}>{ moment( a.created_at ).format( 'DD-MMMM/YYYY' ) }</td>
                              </tr>
                          )
                      })
                  }
              </tbody>
            </table>
        ) :
        (
          <Message negative>
            <Message.Header>Sin Datos</Message.Header>
            <p>No se tienen registradas Activiades al plan: { plan }</p>
          </Message>
        )
      }
      
    </React.Fragment>
  );
};

export default TablaActividades;
